import { GenericModal } from '../GenericModal/GenericModal';
import React, { Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import { LazyQRCodeScanner } from '../../rmx-service/RmxServiceSample/LazyQRCodeScanner';
import type { ModalState } from '../../hooks/useModal';
import type { IDetectedBarcode } from '@yudiel/react-qr-scanner';

interface Props {
  state: ModalState<any>;
  onScan: (result:IDetectedBarcode) => Promise<void>;
}
export function QrCodeScannerModal(props: Props) {
  return (
    <GenericModal state={props.state} shrinkMode={true} showClose={true} label={'Scan Qr Code'}>
      <Suspense fallback={<Spinner />}>
        <LazyQRCodeScanner
          onScan={props.onScan}
          setQrScanner={props.state.setIsOpen}
        />
      </Suspense>
    </GenericModal>
  );
}
